import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const PatientProfile = React.lazy(() => import('../../views/PatientProfile'));

const params = [];
const PatientProfileRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <PatientProfile />
      </Layout>
    </RouteParameter>
  );
};

PatientProfileRoute.propTypes = {};

PatientProfileRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(PatientProfileRoute);
